import { Dialog, Modal } from '@mui/material'
import React from 'react'
import './globalModal.css'

const defaultSx = {
    '& .MuiDialog-paper': {
        minHeight: "5rem",
        minWidth: "20rem",
        borderRadius: "10px",
    },
    backdropFilter: "blur(1px)",
    background: "rgba(0,0,0,0.5)",
    '.css-10d30g3-MuiPaper-root-MuiDialog-paper': {
        maxWidth: "100vw"
    },
    '.css-si425x': {
        maxWidth: "90vw !important"
    }
}

export const GlobalModal = ({ open, onClose, children, dialogSx, disableBackdrop }) => {
    const handleBackdropClick = (event) => {
        event.stopPropagation(); // Intercepta clics fuera del diálogo
    };

    return (
        <Dialog
            sx={{
                ...(dialogSx ?? defaultSx), '.css-10d30g3-MuiPaper-root-MuiDialog-paper': {
                    maxWidth: "100vw"
                },
                '.css-si425x': {
                    maxWidth: "90vw !important"
                }
            }}
            slotProps={{
                backdrop: {
                    style: {
                        background: "transparent",
                    }
                },
            }}
            open={open}
            onClose={(event, reason) => {
                if (disableBackdrop === true) {
                    if (reason !== 'backdropClick') onClose?.();
                } else {
                    onClose?.();
                }
                // if (reason !== 'backdropClick') onClose(); // Evita cerrar con clic fuera
            }}
        //   backdropClick={handleBackdropClick}

        >
            {children ? children : <p className='global-modal-noContent-paragraph'>There is nothing to show , try again.</p>}
        </Dialog>
    )
}
